<template>
    <div>
        <!-- EDITABLE VIEW -->
        <v-select
            v-if="!disableEdit"
            v-model="valueModel"
            solo
            :background-color="color"
            :items="items"
            chips
            label="Selected options"
            placeholder="Select options"
            hint="Selected options"
            :hide-details="true"
            multiple
            item-text="language_tag"
            item-value="id"
            return-object
            auto-focus
            open-on-clear
            :menu-props="menuProps"
            @change="valuesChanged"
        >
            <template slot="item" slot-scope="{item, on, attrs}">

                <div class="d-flex">
                    <v-img class="align-self-center mr-3" max-height="30" max-width="30"
                           :src="cdnBaseUrl(item.image)"></v-img>
                    <div class="align-self-center">
                        {{ item.country }} ({{item.language}})
                    </div>
                </div>
            </template>

            <template
                slot="selection"
                slot-scope="{ item, index }"
            >
                <v-sheet v-if="index < 4" color="grey darken-3" rounded class="pa-2 mr-2 d-flex">
                    <v-img class="align-self-center mr-3" max-height="30" max-width="30"
                           :src="cdnBaseUrl(item.image)"></v-img>
                    <div class="align-self-center">
                        {{ item.code }}
                    </div>
                </v-sheet>
                <span
                    v-if="index === 4"
                    class="white--text caption"
                >(+{{ valueModel.length - 4 }} others)</span>
            </template>

        </v-select>

        <!-- NON EDITABLE VIEW -->
        <v-chip v-if="disableEdit"
                class="ml-1 mt-1"
                text-color="white"
                dark
                small
                label
                color="grey darken-1"
                v-for="locale in valueModel"
                :key="locale.id">
            {{ ucFirst(locale.code) }}
        </v-chip>

    </div>

</template>

<script>

import DataVariableChip from "../../../../components/UI/DataVariableChip";

export default {

    components: {
        DataVariableChip
    },

    props: {
        value: {
            type: Array,
            required: false,
            default: () => [],
        },
        disableEdit: {
            type: Boolean,
            required: false,
            default: false
        },
        color: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            valueModel: [],
            menuProps: {
                maxHeight: '800',
                overflowX: true
            },
        }
    },

    watch: {
        value(values) {
            this.valueModel = this.items.filter(item => values.includes(item.id));
        }
    },

    computed: {

        items() {
            return this.$store.state.PanelSettings.settings.locales;
        },

        selectedLocales() {
            return this.items.filter(item => {
                return this.valueModel.includes(item.id);
            });
        }
    },

    mounted() {
        if (this.value) {
            this.valueModel = this.items.filter(item => this.value.includes(item.id));
        }
    },

    methods: {

        valuesChanged(values) {

            if (values.length === 0) {
                Bus.$emit('flash-message', {
                    type: "warning",
                    message: "Select at least one option or delete this condition!"
                });
            }

            this.$emit('input', values.map(value => value.id));
        },

        formatChipName(item) {
           return item.language_tag;
        },
    }
}
</script>
